import Home from './Home'
const Dashboard = () => <Home />
export default Dashboard
